import { get } from '@/utils/httpHelper';

module.exports = {
  async exportLoginInfo () {
    const url = `/esg/security/admin/report/loginInfo`;
    const body = await get(url);
    return body.data;
  },
  async exportVendorAssessment () {
    const url = `/esg/security/admin/report/vendorAssessment`;
    const body = await get(url);
    return body.data;
  }
};



// WEBPACK FOOTER //
// ./src/repositories/report.repository.js